<div class="ai-content-index-container">
    <!-- Header -->
    <div class="header">
        <h2>AI Content Index - {{ config?.entityLabel || 'University' }} Analysis</h2>
        <!-- <div class="overall-score">
            <span class="score-label">Overall Score:</span>
            <span class="score-value" [ngClass]="getScoreClass(overallScore)"
                [style.color]="getScoreColor(overallScore)">
                {{ overallScore }}/100
            </span>
        </div> -->
    </div>

    <!-- Charts Section -->
    <div class="charts-section"
        *ngIf="(barChartData && barChartData.length > 0) || (radarChartData && radarChartData.length > 0)">
        <div class="chart-container" *ngIf="barChartData && barChartData.length > 0">
            <h3>Content Category Analysis</h3>
            <ngx-charts-bar-vertical-2d [scheme]="colorScheme" [results]="barChartData" [gradient]="false"
                [xAxis]="true" [yAxis]="true" [legend]="false" [showXAxisLabel]="true" [showYAxisLabel]="true"
                xAxisLabel="Content Categories" yAxisLabel="Score" [animations]="true" (select)="onChartSelect($event)" [view]="chartView">
            </ngx-charts-bar-vertical-2d>
        </div>

        <!-- <div class="chart-container"
            *ngIf="radarChartData && radarChartData.length > 0 && radarChartData[0] && radarChartData[0].series && radarChartData[0].series.length > 0">
            <h3>Content Domain Analysis</h3>
            <ngx-charts-bar-horizontal [view]="[800,400]" [scheme]="colorScheme" [results]="radarChartData[0].series"
                [gradient]="false" [xAxis]="true" [yAxis]="true" [legend]="false" [showXAxisLabel]="true"
                [showYAxisLabel]="true" xAxisLabel="Score" yAxisLabel="Content Domains" [animations]="true"
                (select)="onChartSelect($event)">
            </ngx-charts-bar-horizontal>
        </div> -->
    </div>

    <!-- Analysis Section -->
    <div class="analysis-section">
        <div class="analysis-grid">
            <!-- Strengths -->
            <div class="analysis-card strengths" *ngIf="strengths.length > 0">
                <h4>✅ Strengths</h4>
                <ul>
                    <li *ngFor="let strength of strengths">{{ strength }}</li>
                </ul>
            </div>

            <!-- Weaknesses -->
            <div class="analysis-card weaknesses" *ngIf="weaknesses.length > 0">
                <h4>⚠️ Areas for Improvement</h4>
                <ul>
                    <li *ngFor="let weakness of weaknesses">{{ weakness }}</li>
                </ul>
            </div>

            <!-- Recommendations -->
            <div class="analysis-card recommendations" *ngIf="recommendations.length > 0">
                <h4>💡 Recommendations</h4>
                <div class="recommendations-list">
                    <div class="recommendation-item" *ngFor="let rec of recommendations">
                        <div class="recommendation-header">
                            <span class="priority-badge" [ngClass]="'priority-' + rec.priority?.toLowerCase()">
                                {{ rec.priority || 'Medium' }}
                            </span>
                            <span class="category-badge">{{ rec.category || 'General' }}</span>
                        </div>
                        <h5 class="issue-title">{{ rec.issue }}</h5>
                        <p class="recommendation-text">{{ rec.recommendation }}</p>
                        <div class="recommendation-footer">
                            <span class="expected-impact">Expected Impact: {{ rec.expected_impact }}</span>
                            <span class="target-score" *ngIf="rec.target_score">Target Score: {{ rec.target_score
                                }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Evidence Section -->
    <div class="evidence-section" *ngIf="evidence.length > 0">
        <h3>📚 Evidence & Sources</h3>
        <div class="evidence-capsules">
            <div class="evidence-capsule" 
                 *ngFor="let item of evidence; trackBy: trackByEvidence"
                 [matTooltip]="getEvidenceTooltip(item)" 
                 matTooltipPosition="above"
                 matTooltipClass="evidence-tooltip"
                 (click)="openEvidenceLink(item.url)"
                 [title]="'Click to view source: ' + item.url">
                {{ item.title }}
            </div>
        </div>
    </div>

    <!-- No Data Message -->
    <div class="no-data" *ngIf="!tabData">
        <p>No content analysis data available.</p>
        <p>Run a content crawl to generate AI Content Index data.</p>
    </div>
</div>
